import { WizardModel } from '../wizard-model';
import { ConfigurationTemplate } from '../wizard-model.interface';
import { Injectable } from '@angular/core';

@Injectable()
export class ControlCabinetModel extends WizardModel {
  public get type() {
    return 'CONTROL_CABINET';
  }

  private _selectedOptions: {[option: string]: string | string[] | number} = {};

  constructor() {
    super();
  }

  public selectValue(step: number, value: any): void {
    const currentStepConfig = this.config.steps[step];
    if (step < 0 || !currentStepConfig) {
      return;
    }
    const currentStepTitle = currentStepConfig.id;
    this._selectedOptions[currentStepTitle] = value;
  }

  public async create(): Promise<void> {
    // currently overwritten by the mounting rail component
  }

  protected createConfig(): ConfigurationTemplate {
    return {
      id: "create-project-mounting-rail",
      type: 'type',
      imageUrl: "ng-assets/img/projecttypes/control-cabinet.webp",
      label: "configurationCreation.type.control_cabinet",
      steps: [
        {
          type: "meta",
          id: "meta",
          label: "configurationCreation.progress.configuration_data",
        },
        {
          type: "mountingRail",
          id: "mounting",
          label: 'configurationCreation.progress.mounting_rail',
        }
      ]
    }
  }
}
